import { render, staticRenderFns } from "./BannedItem.vue?vue&type=template&id=0d1001ca&scoped=true"
import script from "./BannedItem.vue?vue&type=script&lang=js"
export * from "./BannedItem.vue?vue&type=script&lang=js"
import style0 from "./BannedItem.vue?vue&type=style&index=0&id=0d1001ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1001ca",
  null
  
)

export default component.exports